var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55556 77C6.20278 77 4.18866 76.1623 2.51319 74.4868C0.837731 72.8113 0 70.7972 0 68.4444V8.55556C0 6.20278 0.837731 4.18866 2.51319 2.51319C4.18866 0.837731 6.20278 0 8.55556 0H47.0556V8.55556H8.55556V68.4444H68.4444V29.9444H77V68.4444C77 70.7972 76.1623 72.8113 74.4868 74.4868C72.8113 76.1623 70.7972 77 68.4444 77H8.55556ZM59.8889 25.6667V17.1111H51.3333V8.55556H59.8889V0H68.4444V8.55556H77V17.1111H68.4444V25.6667H59.8889ZM12.8333 59.8889H64.1667L48.125 38.5L35.2917 55.6111L25.6667 42.7778L12.8333 59.8889Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/addImage.6d47d8d2ac852ef0449526965859a85c.svg";
export { ForwardRef as ReactComponent };